// extracted by mini-css-extract-plugin
export default {"l3Nav":"HealthRecords_l3Nav__bpuzf","l2-nav-active":"HealthRecords_l2-nav-active__LYAuf","l3NavActive":"HealthRecords_l3NavActive__WRWZh"};